import { ChangeEvent } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { selectInputMessage } from "../../../selectors";
import { handleChangeInputMessage } from "../../../actions";

export const useTextController = () => {
  const dispatch = useAppDispatch();
  const message = useAppSelector(selectInputMessage);
  const hasMessage = !!message.text.trim().length;

  const setMessage = (message: string) =>
    dispatch(handleChangeInputMessage(message));

  const cleanMessage = () => setMessage("");

  const handleAddNewLine = () => setMessage(`${message.text}\r\n`);

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const { value } = e.currentTarget;

    setMessage(value);
  };

  return {
    message,
    hasMessage,

    handleAddNewLine,
    handleClean: cleanMessage,
    handleChange,
  };
};
